// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v3_productCardWrapper___9OHF"};